import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import axios from "axios";

const PaymentDetails = () => {
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
    const [supplierlist, setSupplier] = useState([]);
    const [filteredCustomerlist, setFilteredCustomerlist] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 25;
    const totalRecords = filteredCustomerlist.length;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    // Calculate records for the current page
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredCustomerlist.slice(
        indexOfFirstRecord,
        indexOfLastRecord
    );

    // Function to change the page
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };
    const handleFilter = (e) => {
    e.preventDefault();

    if (!fromDate || !toDate) {
        console.error("Date fields are empty");
        return;
    }

    // Parse input dates (YYYY-MM-DD format from input fields)
    const startDate = new Date(fromDate);
    startDate.setHours(0, 0, 0, 0); // Ensure the entire day is included

    const endDate = new Date(toDate);
    endDate.setHours(23, 59, 59, 999); // Include full day

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        console.error("Invalid date range");
        return;
    }

    // Filter orders based on date range
    const filtered = filteredCustomerlist.filter((order) => {
        if (!order.added_date) return false; // Skip if order date is missing
console.log(order.added_date);
        // Convert "DD-MM-YYYY" to a Date object
        const [day, month, year] = order.added_date.split("-").map(Number);
        const orderDate = new Date(year, month - 1, day); // Months are zero-based

        // Normalize orderDate to ignore time differences
        orderDate.setHours(0, 0, 0, 0);

        return orderDate >= startDate && orderDate <= endDate;
    });

    setFilteredCustomerlist(filtered);
};

    useEffect(() => {
        setLoading(true);
        axios
            .post(`${API_BASE_URL}payment_details_list.php`)
            .then((response) => {
                if (response.data.head.code === 200) {
                    setSupplier(response.data.body);
                    /*  console.log(response.data.body); */
                    setFilteredCustomerlist(response.data.body);
                } else {
                    setSupplier([]);
                    setFilteredCustomerlist([]);
                    console.error("Error Fetching Data", response.data.head.msg);
                }
            })
            .catch((error) => {
                console.error("API Error:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const [selectedUserId, setSelectedUserId] = useState(null);

    const handleDelete = async () => {
        if (!selectedUserId) {
            alert("Invalid User ID");
            return;
        }

        try {
            const response = await axios.post(
                `${API_BASE_URL}payment_details_delete.php`,
                { id: selectedUserId }
            );

            if (response.data.head.code === 200) {
                //   alert("Customer deleted successfully!");
                window.location.reload();
            } else {
                alert("Error: " + response.data.head.msg);
            }
        } catch (error) {
            console.error("Delete API Error:", error);
            alert("Failed to delete customer. Please try again.");
        }
    };

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        const searchedOrders = supplierlist.filter((supplierlist) => {
            return (
                supplierlist.name?.toLowerCase().includes(query) ||
                supplierlist.mobile?.includes(query) ||
                supplierlist.tax_number?.toLowerCase().includes(query)
            );
        });

        setFilteredCustomerlist(searchedOrders);
        setCurrentPage(1);
    };
    const totalCredit = currentRecords
  .filter(item => item.payment_method === "credit")
  .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

const totalDebit = currentRecords
  .filter(item => item.payment_method === "debit")
  .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

    return (
        <>
            <Header />
            <div class="page-wrapper compact-wrapper" id="pageWrapper">
                <div class="page-body-wrapper">
                    <div class="page-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="card card-table">
                                        <div class="card-body">
                                            <div class="title-header option-title d-sm-flex d-block">
                                                <h5>
                                                    Payment Details Management
                                                </h5>
                                                <div className="right-options">
                                                    <ul>
                                                        <li>
                                                            <Link
                                                                className="btn btn-solid"
                                                                to="/addpaymentdetails"
                                                            // state={{ category_id, subcategory_id }} // pass the id using state
                                                            >
                                                                Add
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                             {/* Date Filter */}
                      <div className="row">
  <div className="col-sm-12">
    <form onSubmit={handleFilter} className="theme-form theme-form-2 mega-form">
      <div className="mb-3 row align-items-center">
        
        {/* From Date */}
        <div className="col-auto text-end">
          <label className="col-form-label form-label-title">From Date:</label>
        </div>
        <div className="col-md-3">
          <input
            className="form-control"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        {/* To Date */}
        <div className="col-auto text-end">
          <label className="col-form-label form-label-title">To Date:</label>
        </div>
        <div className="col-md-3">
          <input
            className="form-control"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        &nbsp;&nbsp;&nbsp;
        {/* Submit Button */}
        <div className="col-md-2">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>

      </div>
    </form>
  </div>
</div>
<br />
                                            {/* <div className="row">
                            <div className="col-sm-6">
                            <form className="theme-form theme-form-2 mega-form">
                                <div className="mb-4 row align-items-center">
                                <label htmlFor="search" className="col-sm-2 col-form-label">
                                    Search:
                                </label>
                                <div className="col-sm-10">
                                    <input
                                    type="text"
                                    id="search"
                                    name="search"
                                    className="form-control"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    />
                                </div>
                                </div>
                            </form>
                            </div>
                        </div> */}
                                            <div>
                                                <div class="table-responsive">
                                                    <table
                                                        class="table all-package theme-table table-product"
                                                        id="table_id"
                                                    >
                                                        {loading ? (
                                                            <div
                                                                className="d-flex justify-content-center align-items-center"
                                                                style={{ height: "200px" }}
                                                            >
                                                                <div
                                                                    className="spinner-border text-primary"
                                                                    style={{ width: "3rem", height: "3rem" }}
                                                                    role="status"
                                                                >
                                                                    <span className="visually-hidden">
                                                                        Loading...
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <thead>
                                                                    <tr>
                                                                        <th >S.No.</th>
                                                                        <th >Date</th> {/* <-- This was missing rowSpan! */}
                                                                        <th >Name</th>
                                                                        <th >Paid To</th>
                                                                        <th >Amount(Credit)</th>
                                                                        <th >Amount(Debit)</th>
                                                                        <th >Description</th>
                                                                        <th  style={{ textAlign: "center" }}>Action</th>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <th>Credit</th>
                                                                        <th>Debit</th>
                                                                    </tr> */}
                                                                </thead>


                                                                <tbody>
                                                                    {currentRecords.length > 0 ? (
                                                                        currentRecords.map((item, index) => (
                                                                            <tr key={item.id}>
                                                                                <td>
                                                                                    {indexOfFirstRecord + index + 1}
                                                                                </td>
                                                                                <td>{item.added_date}</td>
                                                                                <td>{item.name}</td>

                                                                                <td>{item.payment_sent}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.payment_method === "credit" ? item.amount : "-"}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.payment_method === "debit" ? item.amount : "-"}</td>
                                                                                <td style={{ width: "200px", whiteSpace: "normal", wordWrap: "break-word" }}>{item.description}</td>

                                                                                <td>
                                                                                    <ul>
                                                                                        {/* <li>
                                                                                            <Link
                                                                                                to={`/editsupplier/${item.id}`}
                                                                                            >
                                                                                                <i className="ri-pencil-line"></i>
                                                                                            </Link>
                                                                                        </li> */}
                                                                                        <li>
                                                                                            {" "}
                                                                                            <a
                                                                                                href="javascript:void(0)"
                                                                                                data-bs-toggle="modal"
                                                                                                data-bs-target="#deleteModal"
                                                                                                onClick={() =>
                                                                                                    setSelectedUserId(item.id)
                                                                                                }
                                                                                            >
                                                                                                <i className="ri-delete-bin-line"></i>
                                                                                            </a>
                                                                                        </li>
                                                                                    </ul>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="5" className="text-center">
                                                                                No Record found
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {/* TOTAL ROW */}
{/* <tr style={{ fontWeight: 'bold' }}>
  <td colSpan="4" style={{ textAlign: 'right' }}>Total</td>
  <td>{totalCredit.toFixed(2)}</td>
  <td>{totalDebit.toFixed(2)}</td>
  <td colSpan="2"></td>
</tr> */}
<tr id="total">
                            <td colSpan="4">
                              <h3>Total:</h3>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <h3>
                                <i className="fas fa-rupee-sign"></i> {totalCredit.toFixed(2)}
                              </h3>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <h3>
                                <i className="fas fa-rupee-sign"></i> {totalDebit.toFixed(2)}
                              </h3>
                            </td>
                            <td colSpan="2"></td>
                          </tr>

                                                                    <td colSpan="9">
                                                                        <table
                                                                            width="100%"
                                                                            border="1"
                                                                            style={{
                                                                                borderCollapse: "collapse",
                                                                                border: "1px solid #000",
                                                                            }}
                                                                        >
                                                                            <tr>
                                                                                <td width="20%">
                                                                                    Page {currentPage} of {totalPages}
                                                                                </td>
                                                                                <td style={{ textAlign: "right" }}>
                                                                                    {/* Previous Button */}
                                                                                    {currentPage > 1 ? (
                                                                                        <a
                                                                                            className="pagetext"
                                                                                            href="javascript:void(0);"
                                                                                            onClick={() =>
                                                                                                paginate(currentPage - 1)
                                                                                            }
                                                                                        >
                                                                                            &laquo; Previous
                                                                                        </a>
                                                                                    ) : (
                                                                                        <span>&laquo; Previous</span>
                                                                                    )}
                                                                                    &nbsp;
                                                                                    {/* Page Numbers */}
                                                                                    {[...Array(totalPages)].map(
                                                                                        (_, i) => (
                                                                                            <React.Fragment key={i}>
                                                                                                <a
                                                                                                    className={`pagetext ${currentPage === i + 1
                                                                                                        ? "active"
                                                                                                        : ""
                                                                                                        }`}
                                                                                                    href="javascript:void(0);"
                                                                                                    onClick={() =>
                                                                                                        paginate(i + 1)
                                                                                                    }
                                                                                                >
                                                                                                    {i + 1}
                                                                                                </a>
                                                                                                &nbsp;
                                                                                            </React.Fragment>
                                                                                        )
                                                                                    )}
                                                                                    {/* Next Button */}
                                                                                    {currentPage < totalPages ? (
                                                                                        <a
                                                                                            className="pagetext"
                                                                                            href="javascript:void(0);"
                                                                                            onClick={() =>
                                                                                                paginate(currentPage + 1)
                                                                                            }
                                                                                        >
                                                                                            Next &raquo;
                                                                                        </a>
                                                                                    ) : (
                                                                                        <span>Next &raquo;</span>
                                                                                    )}
                                                                                    {/* Last Button */}
                                                                                    {currentPage < totalPages ? (
                                                                                        <a
                                                                                            className="pagetext"
                                                                                            href="javascript:void(0);"
                                                                                            onClick={() =>
                                                                                                paginate(totalPages)
                                                                                            }
                                                                                        >
                                                                                            Last &raquo;&raquo;
                                                                                        </a>
                                                                                    ) : (
                                                                                        <span>Last &raquo;&raquo;</span>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </td>
                                                                </tbody>
                                                            </>
                                                        )}
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="modal fade"
                id="deleteModal"
                tabIndex="-1"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete this customer?
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentDetails;
